export const setItem = (data, key) => {
    // Set Items on local Storage
    key = key ? key : 'dropdownData'
    const newItems = JSON.stringify({[key]: data})
    localStorage.setItem(key, newItems);
}

export const getItem = (key) => {
    // Get Items from local Storage
    const itemData = JSON.parse(localStorage.getItem(key));
    return itemData?.dropdownData
}

export const clearSessionData = (data) => {
    // Clear local storage
    return localStorage.removeItem("dropdownData")
}